import React, { useState } from 'react';

const Disclaimer = () => {
  const [isVisible, setIsVisible] = useState(true);

  const closeDisclaimer = () => {
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div className="fixed bottom-4 right-4 bg-platinum text-sm p-4 rounded-lg shadow-lg opacity-90 transition-opacity duration-300">
        <div className="flex justify-between items-center">
          <p className="mr-2">
            Please note that your data and items will not be processed or saved. They will not be
            shared with any third parties.
          </p>
          <button
            onClick={closeDisclaimer}
            className="font-bold"
          >
            X
          </button>
        </div>
      </div>
    )
  );
};

export default Disclaimer;
